import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Header from '../Header'
import Content from '../Content'

class App extends Component {
	render() {
		const { account } = this.props
		return (
			<div>
				<Header />
				<Content account={account} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		account: state.account
	}
}

const mapDispatchToProps = dispatch => {
	return {
		
	}
}

//  store.dispatch(push('/login'))

export default withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(App));



// WEBPACK FOOTER //
// ./src/components/containers/AppContainer.js